import { Component } from '@angular/core';

@Component({
  selector: 'skeleton-imagen',
  templateUrl: 'skeleton-imagen.html'
})
export class SkeletonImagenComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/skeleton-imagen/skeleton-imagen.ts